import apiService from "@/services/ApiService";
import { USER, USERLIST, USER_IMAGE_UPLOAD, USER_ACTIVE } from "./ApiRoutes";

export const getUsersList = async (payload) => {
  const response = await apiService.post(USERLIST, payload);
  return response.data;
};
export const addUser = async (user) => {
  const response = await apiService.post(`${USER}/`, user);
  return response.data;
};
export const userActiveInactive = async (id, status) => {
  const response = await apiService.get(`${USER_ACTIVE}/${id}`, status);
  return response.data;
};
export const imageUpload = async (image) => {
  const response = await apiService.post(USER_IMAGE_UPLOAD, image);
  return response.data;
};
export const getUserById = async (id) => {
  const response = await apiService.get(`${USER}/${id}`);
  return response.data;
};

export const editUser = async (id, user) => {
  const response = await apiService.put(`${USER}/${id}`, user, {
    headers: {
      "Content-Type": `multipart/form-data`,
    },
  });
  return response.data;
};
